import { makeStyles } from 'tss-react/mui';
import { PDP_ALTERNATE_FLOW_SELECTOR } from '../../utils/constants';
import { colors, spacing, statusColorsFlyingFlowers, statusColorsInterflora } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme, _params, classes) => ({
    selectionButton: {
        minHeight: '108px',
        minWidth: '80px',
        [theme.breakpoints.up('lg')]: {
            minWidth: '112px',
        },
        border: `1px solid ${colors.grey.grey3}`,
        borderRadius: '4px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        '& span': {
            display: 'block',
            '$ .material-icons': {
                color: '#000',
            },
            [`${PDP_ALTERNATE_FLOW_SELECTOR} &`]: {
                color: theme.isFlyingFlowers ? '#3c3c3b' : '#4f4f4f',
            },
        },
        padding: `12px ${spacing.xs} 12px ${spacing.xs}`,
        [`${PDP_ALTERNATE_FLOW_SELECTOR} &`]: {
            padding: `${spacing.xs} ${spacing.xs} ${spacing.small} ${spacing.xs}`,
            width: '100%',
        },
        '&:hover': {
            BackgroundColor: colors.grey.grey1,
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.32)',
            cursor: 'pointer',
            borderColor: colors.grey.grey6,
        },
        '&:focus': {
            BackgroundColor: colors.grey.grey1,
            boxShadow: '0px 0px 8px #008be9, 0px 4px 8px rgba(0, 0, 0, 0.32)',
        },
        [`&.${classes.selected}`]: {
            backgroundColor: theme.isFlyingFlowers ? colors.lazyLime[300] : colors.primary.gold1,
            borderColor: theme.isFlyingFlowers ? theme.statusColors.success.dark : colors.supplementary.black,
            '&:hover': {
                boxShadow: 'none',
            },
            '&:focus': {
                boxShadow: 'none',
            },
        },
    },
    selected: {
        backgroundColor: theme.isFlyingFlowers ? colors.lazyLime[300] : colors.primary.gold1,
        borderColor: theme.isFlyingFlowers ? theme.statusColors.success.dark : colors.supplementary.black,
    },
    variantLabel: {
        minHeight: '56px',
        [theme.breakpoints.up('lg')]: {
            minHeight: '100px',
        },
        alignItems: 'center',
        justifyContent: 'center',
    },
    label: Object.assign(Object.assign({}, theme.typography.xxs_regular), { [theme.breakpoints.up('lg')]: Object.assign({}, theme.typography.small_regular) }),
    title: Object.assign(Object.assign({ display: 'block' }, theme.typography.xxs_bold), { marginBottom: spacing.xs, color: theme.isFlyingFlowers ? colors.black[700] : colors.supplementary.black, [theme.breakpoints.up('lg')]: Object.assign(Object.assign({}, theme.typography.small_bold), { marginBottom: '2px' }), [`${PDP_ALTERNATE_FLOW_SELECTOR} &`]: {
            marginBottom: 0,
            color: theme.isFlyingFlowers ? '#3c3c3b' : '#4f4f4f',
        }, paddingTop: 0, paddingBottom: 0 }),
    supplementary: Object.assign(Object.assign({}, theme.typography.xxs_regular), { color: theme.isFlyingFlowers ? colors.black[700] : colors.supplementary.black }),
    blockedDate: {
        opacity: 0.4,
        cursor: 'not-allowed',
        pointerEvents: 'none',
        '&:hover': {
            boxShadow: 'none',
            borderColor: colors.grey.grey3,
        },
    },
    noTitle: {
        verticalAlign: 'middle',
        justifyContent: 'center !important',
    },
    pccTitle: {
        // display: 'flex',
        // flexDirection: 'column',
        // justifyContent: 'space-between',
        marginBottom: '20px',
    },
    error: {
        border: theme.isFlyingFlowers
            ? `2px solid ${statusColorsFlyingFlowers.error.base}`
            : `1px solid ${statusColorsInterflora.error.base}`,
    },
    tabbedSelectionButton: {
        backgroundColor: colors.supplementary.white,
        border: `1px solid ${colors.grey.grey3}`,
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        flex: '1 0 0',
        minWidth: 0,
        width: '100%',
        minHeight: '84px',
        padding: '8px 4px',
        cursor: 'pointer',
        outline: 'none',
        boxShadow: 'none',
        gap: 0,
        boxSizing: 'border-box',
        alignSelf: 'stretch',
        transition: 'border-color 0.2s ease, background-color 0.2s ease',
        '&:hover': {
            backgroundColor: colors.grey.grey1,
            borderColor: colors.grey.grey6,
            boxShadow: 'none',
        },
        '&:focus': {
            outline: 'none',
            boxShadow: 'none',
        },
        [`&.${classes.tabbedSelected}`]: {
            backgroundColor: `${colors.supplementary.white} !important`,
            border: `1px solid ${colors.supplementary.black} !important`,
            boxShadow: 'none !important',
            '&:hover': {
                boxShadow: 'none !important',
                borderColor: `${colors.supplementary.black} !important`,
            },
        },
    },
    tabbedSelected: {
        backgroundColor: `${colors.supplementary.white} !important`,
        border: `1px solid ${colors.supplementary.black} !important`,
    },
    tabbedError: {
        borderColor: `${statusColorsInterflora.error.base} !important`,
    },
    tabbedCircleIndicator: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '16px',
        height: '16px',
        minHeight: '16px',
        flexShrink: 0,
        margin: 0,
        padding: 0,
    },
    tabbedCircleIconChecked: {
        color: '#2C8500',
        fontSize: '16px !important',
        width: '16px',
        height: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .material-icons': {
            fontSize: '16px !important', // ensure the icon size is consistent with the container
        },
    },
    tabbedCircleIconUnchecked: {
        color: '#333333',
        fontSize: '16px !important',
        width: '16px',
        height: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .material-icons': {
            fontSize: '16px !important', // ensure the icon size is consistent with the container
        },
    },
    tabbedMoreIcon: {
        color: colors.supplementary.black,
        fontSize: '20px !important',
        width: '20px',
        height: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .material-icons': {
            fontSize: '20px !important', // ensure the icon size is consistent with the container
        },
    },
    tabbedMoreIconSelected: {
        color: colors.supplementary.black,
        fontSize: '20px !important',
        width: '20px',
        height: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .material-icons': {
            fontSize: '20px !important', // ensure the icon size is consistent with the container
        },
    },
    tabbedTextContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: '100%',
        margin: 0,
        padding: 0,
    },
    tabbedTitle: Object.assign(Object.assign({ display: 'block' }, theme.typography.xxs_bold), { color: colors.supplementary.black, textAlign: 'center', lineHeight: '24px', height: '24px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%', letterSpacing: '0.2px', margin: 0, padding: 0 }),
    tabbedSupplementary: Object.assign(Object.assign({ display: 'block' }, theme.typography.xxs_regular), { fontSize: '12px', fontWeight: 400, color: colors.supplementary.black, textAlign: 'center', lineHeight: '24px', height: '24px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%', letterSpacing: '0.2px', margin: 0, padding: 0 }),
}));
export default useStyles;
